import {
  Autocomplete,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  FormHelperText,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import AppButton from "../shares/AppButton";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import { useNavigate } from "react-router-dom";
import useConfirm from "../../../hooks/useConfirm";
import { userServices } from "../../../service/UserService";
import { getAccountType, getAccountTypeByCode } from "../../../utils/utilities";

const USER_INFO = {
  is_association: {},
};

const INIT_FORM_ERROR = {
  type_account_error: null,
};

const ChangeAccountType = ({ open, onFormClose }) => {
  const [userInfo, setUserInfo] = useState(USER_INFO);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [submited, setSubmited] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const { Toast, showToast } = useToast();
  const { DialogComponent, openConfirmDialog } = useConfirm();

  const handleFetchUserInfo = () => {
    setLoadingPage(true);
    userServices
      .getMyProfile()
      .then((res) => {
        if (res && res.success) {
          setUserInfo(res.data);
        }
      })
      .finally(() => {
        setLoadingPage(false);
      });
  };

  const handleFormClose = () => {
    onFormClose();
    setUserInfo(USER_INFO);
  };

  const handleChangeType = (e) => {
    const { name, value } = e.target;
    setUserInfo({ ...userInfo, [name]: value });
  };

  const handleCheckDataValidation = () => {
    setFormErrors({
      type_account_error:
        userInfo.is_association === "" || userInfo.is_association === null
          ? "Type de compte requis"
          : null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleUpdateInfo = () => {
    setSubmited(true);
    setSubmitting(true);
    userServices
      .updateUser(userInfo)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmited(false);
        setSubmitting(false);
      });
  };

  const handleSubmit = () => {
    setSubmited(true);
    if (handleCheckDataValidation()) {
      handleUpdateInfo();
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  useEffect(() => {
    handleFetchUserInfo();
  }, [open]);

  useEffect(() => {
    if (userInfo) {
      handleCheckDataValidation();
    }
  }, [userInfo]);

  return (
    <>
      <DialogComponent />
      <Toast />
      <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="xs">
        <Paper sx={{ m: 3 }} elevation={0}>
          <Grid>
            <CardHeader title={"Modifier type de compte"} />
            <CardContent>
              <Grid container>
                <FormControl fullWidth>
                  <Autocomplete
                    options={getAccountType()}
                    getOptionLabel={(option) => option.label}
                    value={getAccountTypeByCode(userInfo.is_association)}
                    onChange={(event, newValue) => {
                      handleChangeType({
                        target: {
                          name: "is_association",
                          value: newValue.code,
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        type="text"
                        placeholder="Ex: Consultant, Association, Agex, …"
                        error={formErrors.type_account_error && submited}
                        helperText={
                          submited ? formErrors.type_account_error : ""
                        }
                      />
                    )}
                  />
                  <FormHelperText id="confirm_helper"></FormHelperText>
                </FormControl>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                loading={submitting}
                text={"Enregistrer"}
                variant={"contained"}
                size={"medium"}
                onClick={(e) => handleSubmit()}
              />
              <AppButton
                text={"Fermer"}
                size={"medium"}
                variant={"outlined"}
                onClick={(e) => handleFormClose()}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default ChangeAccountType;
